import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../../_services/game-mode.service';
import { MiniGameService } from '../../../_services/mini-game.service';
import { ClassStudentsService } from '../../../_services/class-students.service';
import { GamePhase } from '../../../interfaces/game-state.interface';
import { MiniGameType, MiniGameConfig } from '../../../interfaces/mini-game.interface';
import { MINI_GAME_CONFIGS } from '../../../data/mini-game-config';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-game-selector',
  templateUrl: './game-selector.component.html',
  styleUrls: ['./game-selector.component.scss']
})
export class GameSelectorComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';
  games: MiniGameConfig[] = MINI_GAME_CONFIGS;
  studentCount = 0;

  constructor(
    private gameModeService: GameModeService,
    private miniGameService: MiniGameService,
    private classStudentsService: ClassStudentsService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    const classId = this.gameModeService.getCurrentClassId();
    const classStudents = classId ? this.classStudentsService.getStudentsByClass(classId) : [];
    // Fallback to all students when class has no match (dummy data)
    this.studentCount = classStudents.length || this.classStudentsService.getAllStudents().length;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectGame(game: MiniGameConfig): void {
    if (game.requiresStudents && this.studentCount < game.minStudents) return;
    if (game.type === MiniGameType.TUG_OF_WAR) {
      this.miniGameService.goToTeamSetup();
      return;
    }
    if (game.type === MiniGameType.BOWLING) {
      this.miniGameService.goToBowlingSetup();
      return;
    }
    this.miniGameService.startMiniGame(game.type);
  }

  goBack(): void {
    this.gameModeService.setPhase(GamePhase.SUBJECT_PICK);
  }

  getName(game: MiniGameConfig): string {
    return this.currLang === 'ar' ? game.name.ar : game.name.en;
  }

  getDesc(game: MiniGameConfig): string {
    return this.currLang === 'ar' ? game.description.ar : game.description.en;
  }

  isDisabled(game: MiniGameConfig): boolean {
    return game.requiresStudents && this.studentCount < game.minStudents;
  }
}
